<template>
    <div style="background: #fff; display: flex; justify-content: center">
        <div class="xdRegister_css">
            <div class="main_box">
                <div class="user_css">
                    <div class="titleBox">
                        <div class="title">青梨注册</div>
                    </div>
                    <div class="scanQrcode">
                        <!-- <p>打开微信“扫一扫”</p> -->
                        <p style="text-align: left; font-size: 17px; line-height: 30px">
                            输入邮箱获取注册邀请码
                        </p>
                        <div class="imgBox">
                            <el-form :model="register" ref="register" label-width="0px" class="demo-dynamic">
                                <el-form-item prop="email" label="" :rules="[
                                    {
                                        required: true,
                                        message: '请输入邮箱地址',
                                        trigger: 'blur',
                                    },
                                    {
                                        type: 'email',
                                        message: '请输入正确的邮箱地址',
                                        trigger: ['blur', 'change'],
                                    },
                                ]">
                                    <el-input placeholder="请输入邮箱地址" v-model="register.email">
                                        <el-button class="sub_css" slot="suffix" type="primary"
                                            @click="submitForm('register')">提交</el-button>
                                    </el-input>
                                </el-form-item>

                                <!-- <el-form-item>
                  <el-button
                    class="sub_css"
                    type="primary"
                    @click="submitForm('register')"
                    >提交</el-button
                  >
                </el-form-item> -->
                            </el-form>
                        </div>
                        <div class="QrCodeTips">
                            提交成功后，邀请码将发送至您的邮箱，请注意查收！
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request";
export default {
    data() {
        return {
            qrcodeImg: ``,
            img_code: "",
            loading: false,
            register: {
                email: "",
            },
        };
    },
    created() {
        // this.getQrcode();
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.getEmail();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },

        getEmail() {
            this.loading = true;
            request
                .get("user/gdf_bind_invite_code/", {
                    params: {
                        email: this.register.email
                        // invitecode: this.img_code,
                    },
                })
                .then((res) => {
                    this.loading = false;
                    console.log(res);
                    if (res.data.error_code == 0) {
                        this.$message({
                            message: res.data.msg,
                            type: "success",
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    console.log(err);
                    this.$message({
                        message: err,
                        type: "error",
                    });
                });
        },
    },
};
</script>

<style lang="less" scoped>
.xdRegister_css {
    display: flex;
    justify-content: center;
    background-color: #6953da;
    background-size: 100%;
    width: 100%;
    max-width: 540px;
}

.main_box {
    min-height: 100vh;
    width: 100%;

    /* max-width: 800px; */
    /* background-image: url('../../assets/imgs/other/ba_.jpg');  
    background-size: contain; 
    background-position: center; 
    background-repeat: no-repeat;  */

    background: url("../../assets/imgs/other/ba_.jpg") no-repeat top center;
    //   width: 100%;
    background-size: contain;
    padding-top: 55%;
    padding-bottom: 2.5rem;
}

.user_css {
    margin-bottom: 3rem;
    width: 87%;
    margin: 0 auto;

    .titleBox {
        border: 2px solid #a475fe;
        padding: 3px;
        width: fit-content;
        margin: 0 auto;

        .title {
            background-color: #fff;
            font-weight: 600;
            font-size: 20px;
            color: #ae3cf2;
            text-align: center;
            padding: 5px 12px;
            letter-spacing: 2px;
        }
    }
}

.scanQrcode {
    background-color: #fff;
    border-radius: 16px;
    /* 1rem 转为 16px */
    padding: 16px;
    /* 1rem 转为 16px */
    margin: 45px 0;
    /* 1rem 转为 16px */
    box-shadow: 9.6px 9.6px #a066f8;

    /* 0.6rem 转为 9.6px */
    p {
        text-align: center;
        line-height: 25px;
        font-weight: 600;
    }
}

.imgBox {
    margin-top: 15px;

    .imgDiv {
        width: 55%;
        /* 9rem 转为 9 * 16px = 144px */
        margin: 0 auto;
        border: 12.8px solid #ead9ff;
        /* 0.8rem 转为 0.8 * 16px = 12.8px */
        border-radius: 5%;
        /* border-radius 使用百分比保持不变 */
    }

    #QrCodeImg {
        width: 100%;
    }
}

.QrCodeTips {
    //   color: #ab34f0;
    color: #b2b2b2;
    font-size: 13px;
    //   text-align: center;
    text-align: left;
    line-height: 22px;
    padding: 10px 0 5px 0;
}

/deep/ .el-input__suffix {
    display: flex;
    align-items: center;
    justify-content: center;
}

.sub_css {
    display: flex;
    padding: 4px 23px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    align-self: stretch;

    border-radius: 4px;
    border: 1px solid #a066f8;
    background: #a066f8;

    color: #fff;

    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    margin: auto;
}
</style>